export default "__VITE_ASSET__7d45da2f__"